import {
  convertSlashedDMYToAbsoluteDate,
  formatDate,
  isValidAbsoluteDate,
  parseAbsoluteDate,
} from '@dotfile/shared/common';

/**
 * Formats a date string for display
 * Handles both ISO format and DD/MM/YYYY format
 */
export const formatDateValue = (value: string, locale = 'en'): string => {
  // Handle DD/MM/YYYY format
  const absoluteDate = convertSlashedDMYToAbsoluteDate(value);
  if (absoluteDate) {
    return formatDate(parseAbsoluteDate(absoluteDate), { locale });
  }

  // Handle ISO format
  if (isValidAbsoluteDate(value)) {
    return formatDate(parseAbsoluteDate(value), { locale });
  }

  return value;
};
